import { render } from "./UpdateAdmission.vue?vue&type=template&id=3581636a&scoped=true&ts=true"
import script from "./UpdateAdmission.vue?vue&type=script&lang=ts"
export * from "./UpdateAdmission.vue?vue&type=script&lang=ts"

import "./UpdateAdmission.vue?vue&type=style&index=0&id=3581636a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3581636a"]])

export default __exports__